import type { NextPage } from 'next'

import CaptionCard, { CCaptionCardProps } from '~/components/global/CCaptionCard'
import { LightSkyLayout } from '~/components/layout/LightSky'

const Member: NextPage = () => {
    const memberItems: CCaptionCardProps[] = [
        {
            src: '/images/member/yuuhi.jpeg',
            character: '雨宮 夕日',
            furigana: 'あまみや　ゆうひ',
            caption:
                'トカゲの騎士。ある朝、突然現れたトカゲの従者ノイによって騎士に選ばれる。さみだれの破天荒な野望の前に忠誠を誓い、共に地球の破壊を企む。掌握領域は「掌握空域 天の庭（バビロン）」。',
            valet: '従者: ノイ＝クレザント',
            talent: '榎木 淳弥',
        },
        {
            src: '/images/member/samidare.jpeg',
            character: '朝日奈 さみだれ',
            furigana: 'あさひな さみだれ',
            caption:
                '指輪の従者が守るべき姫。関西弁の元気いっぱい少女。精霊アニマの力で爆発的な攻撃力を持つ。アニムスを倒したあかつきには、世界を永遠に自分の物にするために地球の破壊を企んでいる。',
            valet: '精霊: アニマ',
            talent: '大空 直美',
        },
        {
            src: '/images/member/noi.jpg',
            character: 'ノイ＝クレザント',
            caption:
                'トカゲの従者。騎士道精神を重んじ、正義感が強く生真面目。夕日がさみだれと共に地球を壊す計画を阻止したいと思いつつも、夕日の成長を間近で見守る。',
            talent: '津田 健次郎',
        },
        {
            src: '/images/member/anima.jpg',
            character: 'アニマ',
            caption:
                'さみだれと契約を交わした精霊（プリンセス）。アニムスの双子の妹。あまりのマイペースさに、獣の従者達はいつも振り回されている。',
            talent: 'M・A・O',
        },
        {
            src: '/images/member/anims.jpg',
            character: 'アニムス',
            caption:
                '強大な力を持った魔法使い。アニマの双子の兄。常に脱力したスタイルで飄々と現われるが、全ての始まりを知るために地球の破壊を繰り返している。',
            talent: '橘 龍丸',
        },

        {
            src: '/images/member/hangetsu.jpg',
            character: '東雲 半月',
            furigana: 'しののめ はんげつ',
            caption:
                '犬の騎士。古武術の達人で、裏社会では「風神」の異名を持つ。獣の騎士の中でも飛び抜けて戦闘力が高く、さみだれと夕日に戦い方を教える。掌握領域は槍のような力場を敵に打ち込む「方天戟（ほうてんげき）」。',
            valet: '従者: ルド＝シュバリエ',
            talent: '岩瀬 周平',
        },
        {
            src: '/images/member/mikazuki.jpeg',
            character: '東雲 三日月',
            furigana: 'しののめ みかづき',
            caption:
                'カラスの騎士。半月の弟で、強大な兄の背を追い続けている。普段は社交的な性格だが戦闘狂で、強者であれば敵味方を問わず闘いを望む。掌握領域は、槍状の方天戟を大量に降らせて攻撃をおこなう「封天陣（ほうてんじん）」。',
            valet: '従者: ムー',
            talent: '佐藤 元',
        },
        {
            src: '/images/member/soichiro.jpeg',
            character: '南雲 宗一朗',
            furigana: 'なぐも そういちろう',
            caption:
                '馬の騎士。元刑事。騎士たちのリーダー的存在で、責任感が強く生真面目な性格。掌握領域は平面状の力場で相手を拘束する「傾天平面（たかまがはら）」。',
            valet: '従者: ダンス＝ダーク',
            talent: '稲田 徹',
        },
        {
            src: '/images/member/yayoi.jpeg',
            character: '白道 八宵',
            furigana: 'はくどう やよい',
            caption:
                '蛇の騎士。スタイルの良いおっとり美人だが、木刀を持つと果断な判断力を持つ剣士に。趣味はコスプレだが、他人には秘密にしている。掌握領域は武器に纏わせる紐状の「炎状刃（フランベルジュ）」。',
            valet: '従者: シア＝ムーン',
            talent: '洲崎 綾',
        },
        {
            src: '/images/member/shimaki.jpg',
            character: '風巻 豹',
            furigana: 'しまき ひょう',
            caption:
                '黒猫の騎士。大学に勤めて心理学の研究をしている温和な性格の男性。掌握領域は泥人形を創る「創造領域 地母神（キュベレイ）」。',
            valet: '従者: クー＝リッター',
            talent: '松岡 禎丞',
        },
        {
            src: '/images/member/taro.jpg',
            character: '日下部 太朗',
            furigana: 'くさかべ たろう',
            caption:
                'ネズミの騎士。高校生。花子とは幼馴染。料理人を目指しており、夕日と三日月が飲む際はおつまみ作りを担当している。掌握領域は物体を細かく切り刻み、高温を発生させ着火する「荒神（あらがみ）」。',
            valet: '従者: ランス＝リュミエール',
            talent: '土岐 隼一',
        },
        {
            src: '/images/member/hanako.jpg',
            character: '宙野 花子',
            furigana: 'そらの はなこ',
            caption:
                'カマキリの騎士。高校生。成績優秀な高校生で太朗とは幼馴染。喜怒哀楽の感情が希薄。掌握領域は分子をつまんで瞬時に凍らせる「よく冷え～る！？」。',
            valet: '従者: キル＝ゾンネ',
            talent: '廣瀬 千夏',
        },
        {
            src: '/images/member/subaru.jpg',
            character: '星川 昴',
            furigana: 'ほしかわ すばる',
            caption:
                '鶏の騎士。中学1年生で雪待とは幼馴染。見た目や普段の態度と反して、気弱な一面もある。掌握領域は雪待と2人で形成する「無敵の盾」と「最強の矛」。',
            valet: '従者: リー＝ソレイユ',
            talent: '吉武 千颯',
        },
        {
            src: '/images/member/yukimachi.jpg',
            character: '月代 雪待',
            furigana: 'つきしろ ゆきまち',
            caption:
                '亀の騎士。中学1年生で昴とは幼馴染。ゆったりとした物腰だが、いざという時に決断できる気持ちの強さを持っている。掌握領域は昴と2人で形成する「無敵の盾」と「最強の矛」。',
            valet: '従者: ロン＝ユエ',
            talent: '後本 萌葉',
        },
        {
            src: '/images/member/taiyo.jpg',
            character: '茜 太陽',
            furigana: 'あかね たいよう',
            caption:
                'フクロウの騎士。12歳。家庭環境のせいか傍観者的な態度を取ることが多い。アニムスとの戦いに飽いた従者ロキの忠告を聞き、アニムスと接触している。掌握領域は時間をかき乱す能力、混沌領域「因果乱流（パンドラ）」。',
            valet: '従者: ロキ＝ヘリオス',
            talent: '田村 睦心',
        },
        {
            src: '/images/member/inachika.jpg',
            character: '秋谷 稲近',
            furigana: 'あきたに いなちか',
            caption:
                'カジキマグロの騎士。500年間を生き続けた超能力者で、雪待、昴の「師匠」として、二人を鍛えた。掌握領域は雷撃を落とす「天沼矛（アマノヌボコ）」。',
            valet: '従者: ザン＝アマル',
            talent: '山路 和弘',
        },

        {
            src: '/images/member/ludo.jpg',
            character: 'ルド＝シュバリエ',
            caption:
                '犬の従者。半月は幼い頃に飼っていた犬の名である「ノコ」と呼んでいるがルド本人は気に入っていない。前回の戦いでは最後まで生き残った。',
            talent: '石毛 翔弥',
        },
        {
            src: '/images/member/moo.jpeg',
            character: 'ムー',
            caption: 'カラスの従者。無口でほとんど言葉を発しない。',
            talent: '田中 敦子',
        },
        {
            src: '/images/member/dark.jpg',
            character: 'ダンス＝ダーク',
            caption: '馬の従者。男は乗せない主義で、南雲を振り落として腰を負傷させた事がある。',
            talent: '熊谷 健太郎',
        },
        {
            src: '/images/member/sia.jpeg',
            character: 'シア＝ムーン',
            caption: '蛇の従者。性格はお調子者で、八宵のことを「やーこ」と呼ぶ。',
            talent: '氷青',
        },
        {
            src: '/images/member/qoo.jpg',
            character: 'クー＝リッター',
            caption: '黒猫の従者。しっとりした口調で語尾は「～なの」。',
            talent: '掛川 渚',
        },
        {
            src: '/images/member/lance.jpg',
            character: 'ランス＝リュミエール',
            caption: 'ネズミの従者。キルとはケンカをしつつもお互いを気にかけている。',
            talent: '山本 和臣',
        },
        {
            src: '/images/member/kile.jpg',
            character: 'キル＝ゾンネ',
            caption: 'カマキリの従者。一見冷酷で薄情な性格だが、情に熱い一面も持っている。',
            talent: '青木 瑠璃子',
        },
        {
            src: '/images/member/lee.jpg',
            character: 'リー＝ソレイユ',
            caption: '鶏の従者。短気で好戦的な性格。昴を娘のように思っている。',
            talent: '岩田 光央',
        },
        {
            src: '/images/member/ron.jpg',
            character: 'ロン＝ユエ',
            caption: '亀の従者。老人らしくのんびりした性格。',
            talent: '森 功至',
        },
        {
            src: '/images/member/loki.jpg',
            character: 'ロキ＝ヘリオス',
            caption: 'フクロウの従者。哲学者のような口調で話す。アニムスに勝てない戦いを続ける事に疑問を持っている。',
            talent: '村治 学',
        },
        {
            src: '/images/member/zan.jpg',
            character: 'ザン＝アマル',
            caption: 'カジキマグロの従者。見た目通りのインパクトで、稲近を驚愕させた。',
            talent: '住谷 哲栄',
        },

        {
            src: '/images/member/hisame.jpeg',
            character: '朝日奈 氷雨',
            furigana: 'あさひな ひさめ',
            caption: '夕日の通う大学の助教授で、さみだれの姉。妹を溺愛している。27歳で博士号を取得。半月に好意を持たれる。',
            talent: '田所 あずさ',
        },
    ]
    return (
        <LightSkyLayout pageTitle={'キャラクター'}>
            <div className="grid gap-x-10 gap-y-14 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-16 md:mt-10 mx-auto px-4 max-w-6xl">
                {memberItems.map((member: CCaptionCardProps, i: number) => (
                    <CaptionCard
                        key={i}
                        src={member.src}
                        furigana={member.furigana}
                        character={member.character}
                        talent={member.talent}
                        caption={member.caption}
                        valet={member.valet}
                    />
                ))}
            </div>
        </LightSkyLayout>
    )
}

export default Member
